<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-contact-people">
        <i class="far fa-ballot"></i> Contact People List
      </Tab>
    </template>
    <template v-slot:tabcontent>

      <TabPage :first="true" tabid="tab-contact-people">
        <div class="row no-gutter">
          <div class="col-lg-6">
            <ContentTitle>Contact People</ContentTitle>
            <ContentSubTitle>Showing full list of people for active contacts</ContentSubTitle>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <DataTable ref="dataTable" :columns="contactPeopleColumnList" defaultColumnOrderDir="ASC" :defaultColumnOrderIndex="0" :url="contactPeopleURL" :filterOptions="contactPersonFilterOptions" :displayTools="true" :displayFilters="true" :hasDateRangeFilter="false" :displayExportTools="true" exportTitle="Contact People">
              <template v-slot:title>
                <slot name="title" />
              </template>
              <template v-slot:tools>
                <slot name="tools" />
              </template>
              <template v-slot:row="row">
                <tr :key="row.data.id">
                  <td class="table-data-nav-link">
                    <LinkContact :id="row.data.contactId" :name="row.data.contactName" />                    
                  </td>
                  <td>{{row.data.title}}</td>
                  <td>{{row.data.firstName}}</td>
                  <td>{{row.data.lastName}}</td>
                  <td>{{row.data.position}}</td>
                  <td>{{row.data.email}}</td>
                  <td>{{row.data.mobile}}</td>
                  <td>{{formatBoolean(row.data.isDefaultPerson)}}</td>
                  <td>{{formatBoolean(row.data.contactIsSupplier)}}</td>
                  <td>{{formatBoolean(row.data.contactIsCustomer)}}</td>
                  <td>
                    <LabelTags :labelList="row.data.labelList" />
                  </td>
                </tr>
              </template>
            </DataTable>
          </div>
        </div>
      </TabPage>
      
    </template>
  </TabbedBox>
</template>


<script>
import _ from 'lodash'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'

export default {
  name: 'ContactsPeople',
  mixins: [formMixin],
  components: {
  },
  data() {
    return {
      contactPeopleColumnList: [
        { title: "Contact", data: "contactName" },
        { title: "Title", data: "title" },
        { title: "First Name", data: "firstName" },
        { title: "Last Name", data: "lastName" },
        { title: "Position", data: "position" },
        { title: "Email", data: "email" },
        { title: "Mobile", data: "mobile" },
        { title: "Default Person", data: "isDefaultPerson", type: 'boolean' },
        { title: "Contact Supplier", data: "contactIsSupplier", type: 'boolean' },
        { title: "Contact Customer", data: "contactIsCustomer", type: 'boolean' },
        { title: "Labels", data: "labelList", type: 'label', sortable: false }        
      ]
    }
  },
  computed: {
    contactPeopleURL() {
      var params = {
        filter: {
          contactIsActive: 1
        }
      }
      return '/contacts/people?' + $.param(params)
    },
    contactPersonFilterOptions() {
      var filterOptions = [
        {
          name: "Contact Type",
          options: [
            { name: "Customer", value: "contactIsCustomer", class: "label-customer" },
            { name: "Supplier", value: "contactIsSupplier", class: "label-supplier" }
          ]
        },
        {
          name: "Other",
          options: [
            { name: "Default Person", value: "isDefaultPerson", class: "label-customer" },
          ]
        }
      ]

      let contactPersonLabels = this.$store.getters['label/getLabelsByType']('contactPerson')
      filterOptions.push({
        name: 'Contact Person Label',
        field: 'labelListNames',
        operator: 'like',
        options: contactPersonLabels.map(labelInfo => {
            return {
              name: labelInfo.name,
              value: '%' + labelInfo.name + '%',
              colour: labelInfo.colour
            }
        })
      })

      return filterOptions
    }
  },
  mounted() {
    this.requestFilterLabels()
  },
  methods: {
    requestFilterLabels() {
      return new Promise(async (resolve, reject) => {
        try {
          // Get the label info for the filter popovers
          let contactPersonLabels = await this.$apiService.coreService.getLabelsForType('contactPerson')
          this.$store.commit({
            type: 'label/updateLabels',
            labelType: 'contactPerson',
            labelList: contactPersonLabels.data
          })

          return resolve()
        } catch(err) {
          return reject(err)
        }
      })      
    }
  }
}
</script>
